(function () {
  if (window.__cpbInit) return;
  window.__cpbInit = true;
  var C = window.CPB_CONFIG;
  if (!C) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ATTR = 'Geschenk';
  var last = C.total || 0, count = C.count || 0;
  var busy = false, pending = false, timer = null;

  function eur(c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4h14v12H1z"/><path d="M15 8h4l4 4v4h-8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';

  function shell() {
    var d = document.createElement('div');
    d.className = 'cpb';
    d.setAttribute('data-cpb', '');
    var p = (C.ship / C.gift * 100).toFixed(2);
    d.innerHTML = '<p class="cpb__msg" role="status" aria-live="polite"></p>' +
      '<div class="cpb__track"><div class="cpb__fill"></div>' +
      '<div class="cpb__mark" data-m="ship" style="left:' + p + '%">' + TRUCK + '<span>' + esc(C.shipLabel) + '</span></div>' +
      '<div class="cpb__mark" data-m="gift" style="left:100%">' + GIFT + '<span>' + esc(C.giftLabel) + '</span></div></div>';
    return d;
  }

  function message(t) {
    if (t >= C.gift) return '<strong>Geschafft!</strong> Gratis-Versand und ein <strong>Geschenk</strong> sind dabei.';
    if (t >= C.ship) return '<strong>Gratis-Versand</strong> ist drin! Noch <strong>' + eur(C.gift - t) + '</strong> bis zu deinem <strong>Geschenk</strong>.';
    return 'Noch <strong>' + eur(C.ship - t) + '</strong> bis zum <strong>Gratis-Versand</strong>.';
  }

  function hosts() {
    var h = [];
    var d = document.getElementById('CartDrawer-CartItems');
    if (d) h.push({ el: d, before: false });
    var m = document.getElementById('main-cart-items');
    if (m) h.push({ el: m, before: true });
    return h;
  }

  function reorder() {
    if (!C.pushLast) return;
    var needle = '/products/' + C.pushLast;
    ['#CartDrawer-CartItems tbody', '#main-cart-items tbody'].forEach(function (sel) {
      var body = document.querySelector(sel);
      if (!body) return;
      var rows = Array.prototype.slice.call(body.children);
      var move = rows.filter(function (r) { var a = r.querySelector('a[href]'); return a && a.getAttribute('href').indexOf(needle) !== -1; });
      if (!move.length) return;
      var tail = rows.slice(rows.length - move.length);
      if (!move.every(function (r) { return tail.indexOf(r) !== -1; })) move.forEach(function (r) { body.appendChild(r); });
    });
  }

  function enhance() {
    ['#CartDrawer-Checkout', '#checkout'].forEach(function (sel) {
      var b = document.querySelector(sel);
      if (b && C.checkoutLabel && !b.querySelector('.cpb-btn')) {
        b.innerHTML = '<span class="cpb-btn" data-cpb>' + LOCK + '<span>' + esc(C.checkoutLabel) + '</span></span>';
      }
    });
    var empty = document.querySelector('#CartDrawer .drawer__inner-empty a.button');
    if (empty && C.shopUrl && empty.getAttribute('href') !== C.shopUrl) {
      empty.setAttribute('href', C.shopUrl);
      if (C.shopLabel) empty.textContent = C.shopLabel;
    }
  }

  function paint(t, n, from) {
    hosts().forEach(function (h) {
      var bar = h.before
        ? (h.el.previousElementSibling && h.el.previousElementSibling.hasAttribute('data-cpb') ? h.el.previousElementSibling : null)
        : h.el.querySelector(':scope > [data-cpb]');
      if (n === 0) { if (bar) bar.remove(); return; }
      var fresh = false;
      if (!bar) {
        bar = shell(); fresh = true;
        if (h.before) h.el.parentNode.insertBefore(bar, h.el); else h.el.insertBefore(bar, h.el.firstChild);
      }
      var fill = bar.querySelector('.cpb__fill');
      var pct = Math.min(100, t / C.gift * 100);
      if (fresh) {
        fill.style.width = Math.min(100, from / C.gift * 100) + '%';
        requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
      } else {
        fill.style.width = pct + '%';
      }
      var msgEl = bar.querySelector('.cpb__msg');
      var html = message(t);
      if (msgEl.innerHTML !== html) {
        msgEl.innerHTML = html;
        if (!fresh) { bar.classList.remove('is-pop'); void bar.offsetWidth; bar.classList.add('is-pop'); }
      }
      bar.querySelector('[data-m=ship]').classList.toggle('is-done', t >= C.ship);
      bar.querySelector('[data-m=gift]').classList.toggle('is-done', t >= C.gift);
    });
  }

  function quick() {
    reorder();
    enhance();
    var ci = document.getElementById('CartDrawer-CartItems');
    var n = count;
    if (ci && ci.querySelector('tbody tr')) n = Math.max(n, 1);
    paint(last, n, last);
  }

  function syncAttribute(cart) {
    var want = cart.item_count > 0 && cart.total_price >= C.gift ? 'Ja' : '';
    var have = (cart.attributes && cart.attributes[ATTR]) || '';
    if (want === have) return;
    var attrs = {}; attrs[ATTR] = want;
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }

  /* Set-Code (WUNSCHSET4/7/10) nur behalten, solange ein Wunschset im Warenkorb liegt */
  var codeBusy = false;
  function syncSetCode(cart) {
    if (codeBusy) return;
    var best = 0;
    (cart.items || []).forEach(function (i) { var z = parseInt(i.properties && i.properties._set_size, 10) || 0; if (z > best) best = z; });
    var all = (cart.discount_codes || []).map(function (d) { return d.code; });
    var other = all.filter(function (c) { return !/^WUNSCHSET/i.test(c); });
    var setCodes = all.filter(function (c) { return /^WUNSCHSET/i.test(c); });
    var want = best ? ['WUNSCHSET' + best] : [];
    if (setCodes.length === want.length && (!want.length || setCodes[0].toUpperCase() === want[0])) return;
    codeBusy = true;
    var onCart = /\/cart\/?$/.test(window.location.pathname);
    var body = { discount: other.concat(want).join(',') };
    if (!onCart) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (onCart) { window.location.reload(); return; }
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || !d.sections) return;
        if (drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ id: null, sections: d.sections });
          return;
        }
        var doc = new DOMParser().parseFromString(d.sections['cart-drawer'] || '', 'text/html');
        var fresh = doc.querySelector('#CartDrawer'), cur = document.querySelector('#CartDrawer');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          var ov = cur.querySelector('#CartDrawer-Overlay');
          if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
        }
      })
      .catch(function () {})
      .finally(function () { setTimeout(function () { codeBusy = false; }, 1500); });
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        reorder();
        enhance();
        paint(cart.total_price, cart.item_count, last);
        last = cart.total_price; count = cart.item_count;
        syncAttribute(cart);
        syncSetCode(cart);
      })
      .catch(function () {})
      .finally(function () { busy = false; if (pending) { pending = false; schedule(); } });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 60); }

  function isOwn(x) { return x.nodeType === 1 && x.hasAttribute && x.hasAttribute('data-cpb'); }
  function observe(el) {
    if (!el) return;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i];
        if (m.target.closest && m.target.closest('[data-cpb]')) continue;
        var n = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        if (n.length && n.some(isOwn)) continue;
        if (m.target.nodeType === 1 && m.target.matches && m.target.matches('#CartDrawer .drawer__inner-empty a.button')) continue;
        quick();
        schedule();
        return;
      }
    }).observe(el, { childList: true, subtree: true });
  }
  function start() {
    observe(document.querySelector('cart-drawer'));
    observe(document.querySelector('cart-items'));
    observe(document.querySelector('.cart__footer'));
    quick();
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
